// «تسعير الشحن بواسطة الفريق» (owner, 2026-11-01) — the admin side: mark the
// store products whose weight or size we cannot trust (the Cummins generator:
// 14 variants, 2,500–480,000 CNY, all 80 kg). A marked product shows its price
// without shipping and its checkout goes to staff pricing («طلبات السوق»).
// Migration 20261101194558_market_staff_shipping; both RPCs are admin-only.
import { marketRpc } from './marketDb';

export const STAFF_PAGE = 50;

/** kind 'candidates' (the review list) | 'marked' → { ok, total, rows } */
export async function listStaffShipping(kind = 'candidates', offset = 0, limit = STAFF_PAGE) {
  const r = await marketRpc('admin_market_shipping_quote_candidates', { p_kind: kind, p_limit: limit, p_offset: offset });
  if (!r.ok) return { ok: false, error: r.error, total: 0, rows: [] };
  return { ok: true, total: Number(r.data?.total ?? 0), rows: Array.isArray(r.data?.rows) ? r.data.rows : [] };
}

/** Mark (on) or unmark products; returns how many changed. */
export async function setStaffShipping(ids, on, note) {
  const r = await marketRpc('admin_market_set_shipping_quote', { p_product_ids: ids, p_on: !!on, p_note: note || null });
  return r.ok ? { ok: true, n: Number(r.data ?? 0) } : r;
}

/** Why a product is a candidate, in the admin's words. */
export function candidateReason(row, lang = 'ar') {
  const ar = lang === 'ar';
  const out = [];
  if (row.same_weight) out.push(ar ? `${row.variants} موديل بنفس الوزن (${Number(row.kg_max)} كجم) وأسعارها من ${Number(row.price_cny_min).toLocaleString('en-US')} إلى ${Number(row.price_cny_max).toLocaleString('en-US')} يوان`
    : `${row.variants} variants, one weight (${Number(row.kg_max)} kg), prices ${Number(row.price_cny_min).toLocaleString('en-US')}–${Number(row.price_cny_max).toLocaleString('en-US')} CNY`);
  if (row.heavy) out.push(ar ? `موديل وزنه ${Number(row.kg_max)} كجم (فوق 100)` : `a variant of ${Number(row.kg_max)} kg (over 100)`);
  return out.join(' · ');
}
